<template>
    <section :class="[lightMode]">
        <nav class="navbar navbar-expand-lg navbar-dark bg-dark evangelio-lectura">
            <a class="navbar-brand p-3" href="/"><img src="/images/logo.svg"><p class="logo-titulo">Parroquia del Espíritu Santo</p></a>
        </nav>
        <div class="row p-4" v-if="evangelio">
            <div class="col-6 text-left">
                Fecha : {{ formato(evangelio.MIS_FECHA,'DD MMMM, YYYY')}}
            </div>
            
            <div class="col-6 justify-content-end d-flex">
                <div class="btn-group" role="group" style="border: thin solid #999;">
                    <button type="button" @click="lightMode = 'normal'" class="btn btn-light"><Brightness5Icon /></button>
                    <button type="button" @click="lightMode = 'peach'" class="btn btn-warning"><Brightness6Icon /></button>
                    <button type="button" @click="lightMode = 'night'" class="btn btn-dark"><Brightness2Icon /></button>
                </div>
            </div>
            <div class="col-12 pt-5" v-if="evangelio.MIS_PRIMERALECTURA">
                <h1 class="titulo text-uppercase">Primera Lectura</h1>
                <h4 class="cita">{{evangelio.MIS_PRIMERALECTURA_VERSICULO}}</h4>
            
                <div class="evangelio" >
                    <p class=" text-left" v-html="evangelio.MIS_PRIMERALECTURA"></p>
                </div>
            </div>
             <div class="col-12 pt-5" v-if="evangelio.MIS_SEGUNDALECTURA">
                <h1 class="titulo text-uppercase">Segunda Lectura</h1>
                <h4 class="cita">{{evangelio.MIS_SEGUNDALECTURA_VERSICULO}}</h4>
            </div>
            <div class="col-12 pt-5">
                <div class="reflexion text-left" v-if="evangelio.MIS_MEDITATIO">
                    <h4>Meditatio</h4>
                    <p v-html="evangelio.MIS_MEDITATIO"></p>
                </div>
                <div class="reflexion text-left" v-if="evangelio.MIS_ORATIO">
                    <h4>Oratio</h4>
                    <p v-html="evangelio.MIS_ORATIO"></p>
                </div>
                <div class="reflexion text-left" v-if="evangelio.MIS_ACTIO">
                    <h4>Actio</h4>
                    <p v-html="evangelio.MIS_ACTIO"></p>
                </div>
            </div>

            <div class="col-12 pt-5" v-if="evangelio.MIS_EVANGELIO">
                <h1 class="titulo text-uppercase">Evangelio</h1>
                <h4 class="cita">{{evangelio.MIS_EVANGELIO_VERSICULO}}</h4>
            </div>
            <div class="col-12">
                <div class="evangelio" v-if="evangelio.MIS_EVANGELIO">
                    <p class=" text-left" v-html="evangelio.MIS_EVANGELIO"></p>
                </div>
                <div class="reflexion text-left" v-if="evangelio.MIS_REFLEXION">
                    <h4>Reflexión</h4>
                    <p v-html="evangelio.MIS_REFLEXION"></p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Brightness5Icon from 'vue-material-design-icons/Brightness5.vue';
import Brightness6Icon from 'vue-material-design-icons/Brightness6.vue';
import Brightness2Icon from 'vue-material-design-icons/Brightness2.vue';
import moment from 'moment'
require('moment/locale/es')
export default ({
    components:{Brightness2Icon,Brightness5Icon,Brightness6Icon},
    data() {
        return{
            evangelio: {},
            lightMode: 'normal',
        }
    },
    created(){
        this.getEvangelio()
        if(!this.evangelio){
            this.$router.replace('/');
        }
    },
    computed:{
        isAuthenticated(){
            return this.$auth0.isAuthenticated.value
        }
    },
    methods:{
        formato(fecha,formato){
            return moment(fecha).format(formato)
        },
        getEvangelio(){
            fetch(process.env.VUE_APP_PHP_URL,{
                method:'POST',
                body: JSON.stringify({  accion: 'misa' })
            }).then(res=>{
                if(res.ok){
                    return res.json();
                }
            }).then((data)=>{
                this.evangelio = data
            })
        },
        logout(){
            this.$auth0.logout({ returnTo: window.location.origin });
        }
    }
})
</script>
